export default {
  messages: {
    notEnoughCredits: "Nemáte dostatek kreditů na provedení této akce. Přidejte prosím kredity do svého účtu.",
    unableToAnalyzeConversation: "Nepodařilo se nám analyzovat konverzaci.",
    unableToAnalyzeJourney: "Nepodařilo se nám analyzovat kurz.",
    inappropriateContent: "Obsah vašich zpráv nebo zprávy byl nevhodný.",
    responseTooLong: "Odpověď byla příliš dlouhá.",
    responseSlow: "Odpověď byla příliš pomalá.",
    serverError: "Nastala chyba na serveru.",
    serverErrorUpdatingCredits: "Při aktualizaci kreditů člena došlo k chybě.",
    maxMessagesReached: "Bylo dosaženo maximálního počtu zpráv.",
    gameEnded: "Hra byla již ukončena, nemůžete v konverzaci dále pokračovat.",
    nothingToAnalyze: "Nemáte žádné zprávy k analýze.",
    generalChatError: "Při odesílání nastala chyba. Zkuste zprávu odeslat znovu, případně ji zkuste zkrátit.",
    tokenDelay: "Server přestal odpovídat. Zkuste zprávu odeslat znovu, případně stránku znovu načtěte.",
    emailNotVerified: "Váš e-mail nebyl zatím ověřen. Ověřte prosím svůj e-mail a zkuste to znovu.",
    paymentsSessionCreationFailed: "Nepodařilo se vytvořit platební relaci. Zkuste to prosím znovu.",
    minCreditAmountNotReached: "Minimální částka kreditů ve výši {minNumberOfCredits} nebyla dosažena.",
    notEnoughCreditsToStartLesson: "Nemáte dostatek kreditů na zahájení tohoto kurzu.",
    userNotFound: "Uživatel nebyl nalezen.",
    journeyNotFound: "Kurz nebyl nalezen.",
    journeyEnded: "Kurz byl již ukončen, nemůžete ve cvičení dále pokračovat.",
    journeyStepsNotFound: "Kurz nebyl nalezen.",
    unableToGenerateJourneyAnalysis: "Nemáme dostatek informací k vygenerování analýzy kurzu.",
    unableToLoadOrganization: "Nepodařilo se načíst data organizace.",
    invalidInput: "Špatný formát hodnoty",
    unableToFetchLearningPaths: "Nepodařilo se načíst kurzy, obnovte prosím stránku.",
    logoutIssue: "Odhlášení se nezdařilo. Zkuste to prosím znovu.",
    unknownError: "Nastala neznámá chyba.",
    gameLoadIssue: "Nepodařilo se načíst hru. Zkuste to prosím znovu.",
    organizationModulesIssue: "Přenačtěte prosím stránku, nepodařilo se načíst moduly organizace.",
    unableToLoadMicrolearnings: "Přenačtěte prosím stránku, nepodařilo se načíst mikrolearningy.",
    unableToLoadGym: "Přenačtěte prosím stránku, nepodařilo se načíst cvičení.",
    unableToLoadGyms: "Přenačtěte prosím stránku, nepodařilo se načíst cvičení.",
    unableToStreamRespone: "Nepodařilo se získat odpověď.",
    unableToGetAudioResponse: "Nepodařilo se získat audio odpověď.",
    unableToFetchProfile: "Přenačtěte prosím stránku, nepodařilo se načíst hry.",
    unableToFetchLearningPath: "Přenačtěte prosím stránku, nepodařilo se načíst kurz.",
    unableToStartLesson: "Nepodařilo se zahájit kurz.",
    unableToLoadLearningPath: "Přenačtěte prosím stránku, nepodařilo se načíst kurz.",
    unableToStartGame: "Nepodařilo se zahájit hru.",
    unableToEndJourney: "Nepodařilo se ukončit kurz.",
  },
  user: {
    noAccessToOrganization: "Nemáte přístup k této organizaci.",
  },
  buttons: {
    reSendVerificationMail: "Znovu odeslat ověřovací e-mail",
  },
  firebase: {
    "auth/invalid-credential": "Špatný email nebo heslo.",
    "auth/user-not-found": "Uživatel nebyl nalezen.",
    "auth/wrong-password": "Neplatné heslo.",
    "auth/too-many-requests": "Příliš mnoho požadavků. Zkuste to prosím později.",
    "auth/email-already-in-use": "Tento e-mail je již používán.",
    "auth/invalid-email": "Neplatný e-mail.",
    "auth/operation-not-allowed": "Tato operace není povolena.",
    "auth/popup-blocked": "Okno pro přihlášení bylo zablokováno vaším prohlížečem.",
    "auth/quota-exceeded": "Překročili jste povolený počet pokusů o přihlášení.",
  },
};
